import { AxiosResponse } from 'axios'
import { del, get, patch, post, upload } from '../../utils/api'

export const fetchMap = (id: string): Promise<AxiosResponse> =>
  get(`/courses/maps/${id}`, {
    include: [
      'course',
      'courseCount',
      'imageMedia',
      'imageMediaCount',
      'markers',
      'markersCount',
      'markers.moduleLesson',
    ].join(','),
  })

export const fetchCourse = (id: string): Promise<AxiosResponse> =>
  get(`/courses/courses/${id}`, {
    include: ['modules', 'modules.moduleLessons.lesson', 'themes'].join(','),
  })

export const editMap = (
  map_id: string,
  course_id: string,
  image?: File,
  is_active?: boolean
): Promise<AxiosResponse> =>
  image
    ? upload(
        `/courses/maps/${map_id}`,
        {
          field: 'image',
          item: image,
        },
        {
          _method: 'PATCH',
          course_id,
          is_active,
        }
      )
    : patch(`/courses/maps/${map_id}`, {
        course_id,
        is_active,
      })

export const createMarker = (
  map_id: string,
  type?: string,
  position_x?: number,
  position_y?: number,
  module_lesson_id?: string
): Promise<AxiosResponse> =>
  post(`/courses/maps/${map_id}/markers`, {
    type,
    position_x,
    position_y,
    module_lesson_id,
  })

export const editMarker = (
  map_id: string,
  marker_id: string,
  type?: string,
  position_x?: number,
  position_y?: number,
  module_lesson_id?: string
): Promise<AxiosResponse> =>
  patch(`/courses/maps/${map_id}/markers/${marker_id}`, {
    type,
    position_x,
    position_y,
    module_lesson_id,
  })

export const removeMarker = (
  map_id: string,
  marker_id: string
): Promise<AxiosResponse> => del(`/courses/maps/${map_id}/markers/${marker_id}`)
